<template>
  <v-row no-gutters class="mt-3">
    <v-col :cols="12">
      <the-mask
        ref="timeInput"
        :mask="['##:##']"
        class="timeCustom"
        :placeholder="placeholder"
        :value="text"
        />
    </v-col>
  </v-row>
</template>
<script>
import { TheMask } from "vue-the-mask";
export default {
  name: "Time",
  components: {
    TheMask
  },
  props: {
    value: { type: String, default: ""},
    placeholder: {},
  },
  data() {
    return {
      text: ''
    };
  },
  mounted () {
    // watch refs: https://stackoverflow.com/questions/39035498/vuejs-watch-refs
    this.$watch(
    	() => {
    		return this.$refs.timeInput.display
    	},
      (val) => {
        if(val.length < 5) {
          this.text = val
        } else {
          let hour = val.slice(0, 2);
          let minute = val.slice(3, 5)
          hour = (hour >= 24) ? 23 : hour
          if(hour == 23) {
            minute = '59'
          } else {
            minute = (minute > 59) ? 59 : minute
          }
          this.text = `${hour}:${minute}`
          // just change text => display still show wrong
          this.$refs.timeInput.display = `${hour}:${minute}`
        }
        this.$emit('input', this.text)
      }
    )
  },
  methods: {},
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.text = val
      }
    },
  }
};
</script>
